export interface DummyField {
  label: string;
  rawValue?: string | number;
  value?: string | number;
  valueToTranslate?: string;
  size?: 'small' | 'medium' | 'large';
  required?: boolean;
}

export interface DummyRow {
  fields?: DummyField[];
  visible?: boolean;
  customComponent?: 'previous-visits' | 'countries-visits' | 'family-members' | 'divider';
  dividerLabel?: string;
}

export interface DummySection {
  number: number;
  title: string;
  rows: DummyRow[];
}
